import { render } from "./batterys.vue?vue&type=template&id=50f85388&scoped=true"
import script from "./batterys.vue?vue&type=script&lang=js"
export * from "./batterys.vue?vue&type=script&lang=js"

import "./batterys.vue?vue&type=style&index=0&id=50f85388&lang=scss&scoped=true"

import exportComponent from "E:\\zhouwang\\work\\web_dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50f85388"]])

export default __exports__